<template lang="pug">
div.leadershipOffice
  Button(icon="md-add",style='color:#3A76D2;border: 1px solid #3A76D2;margin-left: 12px;transform: translateY(-10px);',
    @click='showAIDialog()',v-if='enableAI') AI生成
  Modal(v-model="aiDialogVisible" title="AI生成" @on-ok="generateCase")
    Form(:model="aiForm" :label-width="80")
      FormItem(label="对话轮数")
        InputNumber(v-model="aiForm.dialogue_count" :min="2" :max="6" placeholder="请输入对话轮数")
      FormItem(label='提示词',prop="stem")
        Input(v-model='aiForm.system' placeholder='请填写提示词'
          type="textarea" :rows="3")
  .topTitle
    span 领导办公室
    .btns
      Icon(type="md-arrow-dropup",@click="$emit('upData',eachIndex,DATA,)")
      Icon(type="md-arrow-dropdown",@click="$emit('downData',eachIndex,DATA)")
      Icon(type="md-git-branch",@click='logic')
      Icon(type="ios-trash",@click='delModel')
  .talkImg
    img(src="../../assets/case/department/leadershipOffice.png")
  p.talkset() 对话设置
  ul.talkContent
    li(v-for="(item, index) in talkList",:key="index")
      .talker
        span #
        span {{item.name}}
      .content(@click="changeIndex(index)")
        //- span(v-show="idx !== index") {{item.content}}
        Input(
          type='textarea'
          ref="inputBox",
          v-model="item.content",
          placeholder="请填写谈话内容",
          @on-blur="returnBack()")
      .deleteIcon
        Icon(type="md-close-circle",@click="deleteTask(index)")
  .button1
    Button(icon="md-add",
      style='color:#3A76D2;border: 1px solid #3A76D2;text-align:left;margin: 0 74px 16px',
      @click="add_task('领导讲话内容')") 添加领导讲话
    Button(icon="md-add",
      style='color:#3A76D2;border: 1px solid #3A76D2;text-align:left;margin-top: -16px;',
      @click="add_task('分析师讲话内容')") 添加分析师讲话

  component(v-for='(item,index) in assemblyList',
    v-if="condition"
    :key='index',
    @delModel='delCom(index)',
    :ref="item.name + index",
    :is='item.name',
    :data='item.data'
      v-disabled="seeState"
    @upData='upData(index)',
    @downData='downData(index)',
    @data1:data="val => item.data = val"
    :tableData.sync="tableData"
    :ha-id="haId"
    :task-id="taskId"
    :enableAI="enableAI"
    ).model
  div.drag(@drop="fun_drop",@dragover="allowDrop")
    p  把题型或者案例内容拖入此区域吧!
</template>

<script>
import mybus from "@/utils/main";
import Single from "../case/single";
import MultipleA from "../case/multiple";
import MultipleB from "../case/multiple";
import Fillblank from "../case/fillblank";
import EasyQuestion from "../case/easyQuestion";
import Material from "../case/material";
import CaseAxis from "../case/caseAxis";
import CaseTitle from "../case/caseTitle";
import CaseDialogue from "../case/caseDialogue";
import CaseGuide from "../case/caseGuide";
import CasePhotoText from "../case/casePhotoText";
import CaseInfoBase from "../case/caseInfoBase";
import CaseDepartment from "../case/caseDepartment";
import CaseUpload from "../case/caseUpload";
import CaseAskAndAnswer from "../case/caseAskAndAnswer";
import TableQuestion from "../case/tableQuestion";
import ligatureQuestion from "../case/ligatureQuestion";
import determineQuestion from "../case/determineQuestion";
import CaseSingleText from "../case/caseSingleText";
import CaseTitleText from "../case/caseTitleText";
import CaseVideo from "../case/caseVideo";
import MultipeChoice from "../case/multipeChoice";
import Divider from "../case/divider";
import smallCaseTitle from "../case/smallCaseTitle";
import Bus from "../../utils/bus";

export default {
  inject: ["seeState"],

  props: [
    "assemblyName",
    "info",
    "eachIndex",
    "data",
    "fun_office1",
    "taskId",
    "haId",
    "taId",
    "cdId"
  ],
  components: {
    Single,
    MultipleA,
    MultipleB,
    Fillblank,
    EasyQuestion,
    Material,
    CaseAxis,
    CaseDialogue,
    CaseGuide,
    CaseTitle,
    CasePhotoText,
    CaseSingleText,
    CaseInfoBase,
    CaseDepartment,
    CaseUpload,
    CaseAskAndAnswer,
    determineQuestion,
    TableQuestion,
    ligatureQuestion,
    CaseTitleText,
    CaseVideo,
    MultipeChoice,
    Divider,
    smallCaseTitle
  },
  data() {
    return {
      condition: true,
      assemblyList: [],
      form: {
        logic: ""
      },
      // caseValue: ["FORMULATE", "EXECUTE", "ASSESS", "FINALITY"],
      talkList: [
        {
          name: "领导讲话内容",
          content: ""
        },
        {
          name: "分析师讲话内容",
          content: ""
        },
        {
          name: "领导讲话内容",
          content: ""
        }
      ],
      idx: -1,
      tableData: {},
      enableAI: false,
      aiDialogVisible: false,
      aiForm: {}
    };
  },
  watch: {
    tableData: {
      handler(val) {
        this.$emit("updateTableData", val);
      },
      deep: true,
      immediate: true
    },
    fun_office1: {
      handler(val) {
        if (val) {
          this.talkList = JSON.parse(this.fun_office1);
        }
      },
      deep: true,
      immediate: false // 初始时触发
    },
    haId(newVal) {
      if (!newVal) {
        this.initHaId();
      }
    }
  },
  computed: {
    caseValue() {
      return this.$store.state.Case.caseValue;
    },
    fun_office() {
      return JSON.stringify(this.talkList);
    },
    DATA() {
      return { talkList: this.talkList, assemblyList: this.assemblyList };
    },
    List() {
      return this.getData;
    },
    taskList() {
      return this.$store.state.task.task;
    }
  },
  created() {
    console.log(this.data);
    if (this.data) {
      this.assemblyList = this.data.assemblyList || this.data;
    }
    if (this.fun_office1) {
      this.talkList = JSON.parse(this.fun_office1);
    }
  },
  methods: {
    async initHaId() {
      const index = +sessionStorage.getItem("CaseStage") - 1;
      const caseData = this.$store.state.Case.caseData?.[this.caseValue[index]];

      if (caseData?.HallId) {
        this.haId = caseData.HallId;
      } else {
        try {
          const res = await this.$http.getCasehallByPyIdAndCaseStep({
            pyId: this.Case?.basic?.id,
            caseStep: this.caseValue[index]
          });
          if (res.data.success) {
            this.haId = res.data.data.id;
          }
        } catch (e) {
          console.error("重新获取 haId 失败", e);
        }
      }
    },
    checkEnableAI() {
      this.$http
        .getEnableState()
        .then((res) => {
          if (res.data.success) {
            this.enableAI = res.data.data;
          } else {
            this.enableAI = false;
          }
        })
        .catch(() => {
          this.enableAI = false;
        });
    },

    showAIDialog() {
      this.aiDialogVisible = true;
      this.aiForm = { dialogue_count: 2, system: "" };
    },
    generateCase() {
      if (this.haId === "" || this.haId === null || this.haId === undefined) {
        this.$Message.error("无法生成！原因：已存在领导办公室场景！");
        return;
      }
      const data = {
        inputs: {
          opt_type: "LEADERSHIPOFFICE",
          pyId: this.$store.state.Case.basic.id,
          tsId: this.taskId,
          // haId: this.haId,
          score: 2,
          system: this.aiForm.system,
          dialogue_count: this.aiForm.dialogue_count,
          taId: this.taId,
          cdId: this.haId
        }
      };
      this.$http.generateCase(data).then((res) => {
        if (res.data.success) {
          this.$Message.success("保存成功");
          if (this.taskId !== this.haId) {
            Bus.$emit("refresh-task", this.taskId);
          } else {
            this.$emit("refresh-query");
          }
        }
      });
    },
    upData(index) {
      // 题目点击向上移动
      if (index === 0) {
        return this.$Message.error("已经是第一个控件啦");
      }
      this.condition = false;

      [this.assemblyList[index], this.assemblyList[index - 1]] = [
        this.assemblyList[index - 1],
        this.assemblyList[index]
      ];
      this.$forceUpdate();
      setTimeout(() => {
        this.condition = true;
      }, 0);
    },
    downData(index) {
      // 题目点击向上移动

      if (index + 1 === this.assemblyList.length) {
        return this.$Message.error("已经是最后一个控件啦");
      }
      this.condition = false;

      [this.assemblyList[index], this.assemblyList[index + 1]] = [
        this.assemblyList[index + 1],
        this.assemblyList[index]
      ];
      this.$forceUpdate();
      setTimeout(() => {
        this.condition = true;
      }, 0);
    },
    endDrag() {
      // 结束拖动事件
    },
    startDrag() {
      // 开始拖动事件

      // 向父组件暴露拖拽事件
      this.$emit("startDrag");
    },
    getData(data) {
      return data;
    },
    delCom(index) {
      // delete this.assemblyList[index];
      if (!this.assemblyList[index].data || !this.assemblyList[index].data.id) {
        this.assemblyList.splice(index, 1);
        return;
      }
      console.log(this.assemblyList[index].data.id);
      if (this.assemblyList[index].data.id) {
        /** 如果有ID 则需要调用后端接口 */
        this.$store.commit("deleteControl", this.assemblyList[index].data.id);
      }
      // 直接删除
      this.assemblyList.splice(index, 1);
      const obj = {};
      obj.type = "领导办公室";
      obj.deleteIndex = index;
      this.$store.commit("deleteQues", obj);
    },
    // 删除部门
    delModel() {
      this.$emit("delModel", "LEADERSHIPOFFICE");
    },
    changeIndex(index) {
      setTimeout(() => {
        this.idx = index;
        this.$nextTick(() => {
          this.$refs.inputBox[index].focus();
        });
      }, 50);
    },
    fun_drop() {
      if (this.assemblyName !== "") {
        this.assemblyList.push({ name: this.assemblyName, data: {} });

        const obj = {};
        obj.type = "领导办公室";
        obj.listChild = this.assemblyName;
        this.$store.commit("addQues", obj);
      }
    },
    allowDrop(e) {
      e.preventDefault();
    },
    add_task(type) {
      this.talkList.push({
        name: type,
        content: ""
      });
      this.$nextTick(() => {
        this.idx = this.$refs.inputBox.length - 1;
        this.$refs.inputBox[this.idx].focus();
      });
    },
    deleteTask(index) {
      this.talkList.splice(index, 1);
    },
    returnBack() {
      this.idx = -1;
    }
  },
  mounted() {
    this.checkEnableAI();
    this.haId =
      this.$store.state.Case.caseData[
        this.caseValue[+sessionStorage.getItem("CaseStage") - 1]
      ].HallId;
    console.log(this.taskId);
    mybus.$on(`add${this.eachIndex}`, this.ObtainSubject);
  }
};
</script>

<style lang="stylus">
.leadershipOffice
  width 854px
  padding 16px 32px 60px 32px
  .topTitle
    text-align left
    height 32px
    line-height @height
    position relative
    margin-bottom 16px
    font-size 14px
    font-weight bold
    color rgba(42, 46, 54, 0.8)
    .btns
      position absolute
      right 0
      top 0
      .ivu-icon
        color #3A76D2FF
        font-size 22px
        top 0
        margin-right 12px
        background #F2F5FAFF
        width 24px
        height 24px
        border-radius 4px
        text-align center
        line-height @height
        &:hover
          cursor pointer
  .talkImg
    margin-bottom 24px
    img
      width 100%
  .talkset
    height 32px
    line-height @height
    text-align left
    color rgba(42, 46, 54, 1)
    font-size 14px
    margin-bottom 24px
  .talkContent
    li
      display flex
      width 100%
      margin-bottom 16px
      div
        flex 1
      .talker
        flex 0 0 120px
        text-align left
        margin-right 14px
        font-size 14px
        color rgba(42, 46, 54, 1)
      .content
        text-align left
        margin-right 7px
        font-size 14px
        color rgba(42, 46, 54, 0.75)
      .deleteIcon
        flex 0 0 20px
        position relative
        .ivu-icon
          position absolute
          top 50%
          margin-top -10px
          font-size 20px
          color #E72020
          width 20px
          height 20px
  .button1
    text-align left
    padding-bottom 10px
    border-bottom 1px solid rgba(42, 46, 54, 0.3)
  .drag
    min-width 790px
    height 100px
    background #fff
    border-radius 4px
    border 1px dashed rgba(128, 128, 128, 0.5)
    margin-top 24px
    cursor alias
    p
      font-size 14px
      font-family MicrosoftYaHeiUI
      color rgba(128, 128, 128, 0.5)
      line-height 100px
      text-align center
</style>
